import {
  Zap,
  Activity,
  Gauge,
  ShieldCheck,
  BarChart3,
  DatabaseZap,
  Workflow,
  Layers,
} from 'lucide-react';
import type { FeatureGroup } from '../types';

export const performanceGroup: FeatureGroup = {
  id: 'performance',
  label: 'Performance & Quality',
  headline: 'Fast by design',
  summary:
    'Meshpit runs OpenSCAD in WebAssembly, compiles multi-color models across a parallel worker pool, and runs the Monaco editor in its own thread — so nothing ever blocks the UI. Smart caching and compilation gates ensure WASM runs only when it needs to.',
  accentClass: 'from-orange-500 to-red-400',
  items: [
    {
      icon: Zap,
      title: 'OpenSCAD in WebAssembly',
      description:
        'The full OpenSCAD compiler runs locally in your browser via WebAssembly. No server roundtrip — changes compile and render in real-time as you type.',
      tier: 'major',
    },
    {
      icon: Activity,
      title: 'Parallel Worker Pool',
      description:
        "Multi-color models compile in a four-worker pool — each color renders the moment it's ready, so you see the model build up progressively rather than waiting for all colors.",
      tier: 'major',
    },
    {
      icon: ShieldCheck,
      title: 'Printability Checker',
      description:
        'Automated mesh analysis checks for watertightness, non-manifold geometry, thin walls, degenerate faces, and inter-object collisions — all before you hit print.',
      tier: 'major',
    },
    {
      icon: Gauge,
      title: 'Performance Mode',
      description:
        'Toggle performance mode to reduce post-processing fidelity and maximise render throughput — useful for complex models with high polygon counts.',
      tier: 'minor',
    },
    {
      icon: DatabaseZap,
      title: 'Compilation Caching',
      description:
        'The WASM worker caches compiled results so unchanged geometry is never recompiled. Only modified colors or files trigger a new compilation pass.',
      tier: 'minor',
    },
    {
      icon: Workflow,
      title: 'Smart Compilation Gate',
      description:
        'The WASM compiler is only invoked when the editor has no syntax errors — preventing needless compilation cycles on every keystroke.',
      tier: 'minor',
    },
    {
      icon: Layers,
      title: 'Streaming Mesh Rendering',
      description:
        'Each color group is added to the Three.js scene the moment it finishes compiling — the model builds up progressively rather than appearing all at once.',
      tier: 'minor',
    },
    {
      icon: BarChart3,
      title: 'Performance Stats',
      description:
        'Live FPS display and web worker performance stats let you see exactly where time is being spent during compilation and rendering.',
      tier: 'minor',
    },
  ],
};
